import axios from 'axios';
import api from '../../../utils/api';

export default {
  addComment({}, Commentdata) {
    return axios(api.comments.create(Commentdata));
  },
  async fetchComment({ commit }, postId) {
    const { data } = await axios(api.comments.fetch(postId));
    commit(
      'postsLikeUnlike/ALL_POST_COMMENT_LIKES',
      { posts: data.results },
      { root: true },
    );
    return data;
  },
  async fetchSharedComment(_, postId) {
    const { data } = await axios(api.comments.fetchShared(postId));
    return data;
  },
  async fetchCommentsNextPage({ commit }, url) {
    const { data } = await axios(api.comments.fetchNextPage(url));
    commit(
      'postsLikeUnlike/ALL_POST_COMMENT_LIKES',
      { posts: data.results },
      { root: true },
    );
    return data;
  },
};
